import { RemoteObjectStore, StoreBuilder } from "@softline/core";
import { PersonalUebersichtDetail } from "../types/mitarbeiter";

export const PmsPersonalDetailStore = new StoreBuilder(RemoteObjectStore.create<PersonalUebersichtDetail>()).value